import { useTheme } from '@mui/material';

function useChartColor() {
    var theme = useTheme();
    return {
        green: theme.palette.chart.green,
        red: theme.palette.chart.red,
    };
}

export { useChartColor };
